export default "__VITE_ASSET__D6NGmf7h__"